import { useState, useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { deleteOwner } from 'store/owners/actions'
import type { DeleteOwnerResponse } from 'store/owners/types'

export interface UseDeleteOwnerResult {
  deleteOwner: (ownerId: string) => Promise<{ success: boolean; data?: DeleteOwnerResponse; error?: any }>
  isLoading: boolean
}

export const useDeleteOwner = (): UseDeleteOwnerResult => {
  const dispatch = useDispatch()
  const [isLoading, setIsLoading] = useState(false)

  const handleDeleteOwner = useCallback(async (ownerId: string): Promise<{ success: boolean; data?: DeleteOwnerResponse; error?: any }> => {
    setIsLoading(true)
    
    return new Promise((resolve) => {
      dispatch(deleteOwner(
        { ownerId },
        (result: { success: boolean; data?: DeleteOwnerResponse; error?: any }) => {
          setIsLoading(false)
          resolve(result)
        }
      ))
    })
  }, [dispatch])

  return {
    deleteOwner: handleDeleteOwner,
    isLoading,
  }
}
